import axios from 'axios';
import * as CONSTANTS from "../constants/constants";

let http = axios.create({
  baseURL: CONSTANTS.API_URL,
  timeout: 50000
});

export default http; 